import { Platform } from "react-native";
import { OneSignal as RNOneSignal } from "react-native-onesignal";

export const OneSignal = Platform.select({
	ios: RNOneSignal,
	android: RNOneSignal,
	default: null,
});
